import { __assign } from "tslib";
import * as ColorUtil from './color';
import * as LayoutUtil from './layout';
import * as GpuUtil from './gpu';
import * as BrowserUtil from './browser';
import { Util } from '@antv/g6-core';
var G6Util = __assign(__assign(__assign(__assign(__assign({}, Util), ColorUtil), LayoutUtil), GpuUtil), BrowserUtil);
export default G6Util;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-pc/es/util/index.js
// module id = null
// module chunks = 